// helpers/Coveo/NoResultsMessage.tsx

import React, { JSX } from 'react';
import { useCoveoEngine } from 'lib/utils/coveo/SearchContext/CoveoEngineContext';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { useSiteSettings } from 'lib/utils/page-data-static-props/pageDataContext';

type NoResultsMessageProps = {
  className?: string;
};

const NoResultsMessage = ({ className }: NoResultsMessageProps): JSX.Element | null => {
  const siteSettings = useSiteSettings()?.fields;

  const engine = useCoveoEngine();
  const query = engine?.state?.query?.q || '';

  const rawHtml = siteSettings?.noSearchResultText?.value || '';

  if (!rawHtml) return null;

  const htmlWithReplacedTerm = rawHtml.replace(/{searchterm}/gi, query);

  return (
    <div className={className}>
      <RichTextWrapper
        field={{ value: htmlWithReplacedTerm }}
        className="
            py-16
            font-nunitoSans
            text-gray-900
            text-20
            leading-25

            [&_.heading]:border-b 
            [&_.heading]:border-gray-100 
            [&_.heading]:pb-12

            [&>ul]:pl-6 
            [&>li]:mb-2
        "
      />
    </div>
  );
};

export default NoResultsMessage;
